export default __webpack_public_path__ + "static/media/snoot.42b2fe06.png";